import React from 'react';
import NavigationBar from '../Shared/NavigationBar/NavigationBar';
import ContactForm from './ContactForm/ContactForm';

const Contact = () => {
    return (
        <div>
            <NavigationBar/>
            <ContactForm/>
        </div>
    );
};

export default Contact;